import api from "app/api/requests/Gallery";
import getChatToken from "app/api/getChatToken";

export const DELETE_RESOURCE = 'DELETE_RESOURCE';

export const deleteResource = (payload: { id: string, albumId: string }) => (dispatch: any): any => {
	const token = getChatToken();
	return api.deleteResource(payload.id, payload.albumId, token)
		.then(() => {
			dispatch({
				type: DELETE_RESOURCE, payload
			});
		});
};
